/* store/index */
import Vue from 'vue'
import Vuex from 'vuex'

import app from '@/store/modules/app.js'
import blockUI from '@/store/modules/blockUI.js'
import message from '@/store/modules/message.js'
import snackbar from '@/store/modules/snackbar.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        blockUI,
        message,
        snackbar
    }
})
